import React from 'react';
import { getLegendItemsFromSeries } from './utils';

interface SeriesLegendOptions {
  showHistoricalProjection?: boolean;
}

export const LEGEND_TYPES = {
  LINE: 'line',
  SCATTER: 'scatter',
} as const;

export type LegendType = (typeof LEGEND_TYPES)[keyof typeof LEGEND_TYPES];

export interface SeriesLegendProps {
  className?: string;
  type?: LegendType;
  options?: SeriesLegendOptions;
}

const SeriesLegend: React.FC<SeriesLegendProps> = ({ className = '', type = LEGEND_TYPES.LINE, options = {} }) => {
  const legendItems = getLegendItemsFromSeries(options);

  if (legendItems.length === 0) {
    return null;
  }

  const typeClass = type === LEGEND_TYPES.SCATTER ? 'scenario-graph-legend--scatter' : '';
  const fullClassName = `series-legend scenario-graph-legend ${typeClass} ${className}`.trim();

  return (
    <div className={fullClassName}>
      {legendItems.map(item => (
        <span key={item.label} className={item.className}>
          {item.label}
        </span>
      ))}
    </div>
  );
};

export default SeriesLegend;
